import React, { useEffect, useState } from 'react';

import { WorkAbstractLite } from 'js/academia_components/cards/work_card/work_abstract';
import { WorkContainer } from 'js/academia_components/cards/work_card/work_container';
import { WorkTitle } from 'js/academia_components/cards/work_card/work_title';
import { getMention, SetMentionResult } from 'js/mentions/async_utils';
import { Action, Mention } from 'js/mentions/common';
import Placeholder from 'js/utils/components/Placeholder';
import getQSParams from 'js/utils/getQSParams';
import { MentionCard } from './MentionCard';

const { featured: mentionId } = getQSParams('featured');

interface Props {
  hideLoading?: boolean;
  onAction: (a: Action) => Promise<SetMentionResult>;
  isFeaturedCitationContext: boolean;
}

const FeaturedMention: React.FC<Props> = ({
  hideLoading = true,
  onAction,
  isFeaturedCitationContext,
}) => {
  const [mention, setMention] = useState<Mention>();

  useEffect(() => {
    if (mentionId) getMention(parseInt(mentionId)).then(setMention);
  }, []);

  /** Update mention in state if we change it */
  const update = async (action: Action) => {
    const result = await onAction(action);
    setMention((prevMention) => {
      if (!prevMention) return;
      return { ...prevMention, ...result };
    });
  };

  if (!mentionId || (!mention && hideLoading)) return null;
  return (
    <>
      {mention ? (
        <MentionCard
          {...mention}
          onAction={update}
          highlyCited={mention.highly_cited}
          isFeaturedCitationContext={isFeaturedCitationContext}
        />
      ) : (
        loading
      )}
      {!isFeaturedCitationContext && <hr className="u-borderColorGray" />}
    </>
  );
};

const loading = (
  <div>
    <div className="wp-card__spacer">
      <div className="wp-card__container" />
    </div>
    <WorkContainer tall={false}>
      <WorkTitle>
        <Placeholder />
      </WorkTitle>
      <WorkAbstractLite expanded lessButton={false}>
        <Placeholder small />
      </WorkAbstractLite>
      <WorkAbstractLite expanded lessButton={false}>
        <Placeholder small />
      </WorkAbstractLite>
    </WorkContainer>
  </div>
);

export default FeaturedMention;
